export default __webpack_public_path__ + "static/media/bg-bridge.26851657.png";